export const scaleOf = (values: number[]) => {
  const lowest = Math.min(...values);
  const highest = Math.max(...values);
  return (value: number) => (highest === lowest ? 0 : ((value - lowest) / (highest - lowest)) * 100);
};
